module.exports = function getResource(label, vars = []) {
    let resources = {
        addedErrorMessage: 'Ce Color IQ a déjà été ajouté',
        defaultErrorMessage: 'Color IQ non valable',
        defaultSkintone: 'Teint par défaut',
        addNewColorIQ: 'Ajouter une nouvelle couleur IQ',
        enterSkintoneNumber: 'Saisir le numéro de teint',
        addButton: 'Ajouter',
        capturedOn: 'Déterminé le'
    };

    return resources[label];
};
